import React, { useEffect, useMemo } from 'react'
import { AppDispatch, RootState } from '../../redux-stores/store'
import { useDispatch } from 'react-redux'
import { setHeader, toggleAddSocialAccountModal, toggleProfileUpdateModal } from '../../redux-stores/slices/layoutSlice';
import { useNavigate } from 'react-router-dom';
import Avatar from 'react-avatar';
import { useSelector } from 'react-redux';
import "./style.scss";
import EditIcon from '../../assets/icons/EditIcon';
import PhoneIcon from '../../assets/icons/PhoneIcon';
import BirthdayIcon from '../../assets/icons/BirthdayIcon';
import { Link } from 'react-router-dom';
import { INIT_IG_AUTH_ROUTE, platforms, WHATSAPP_SUPPORT_NUMBER } from '../../constants/constants';
import SocialAccountProfileCard from '../../components/profile/SocialAccountProfileCard';
import CollaborationIcon from '../../assets/icons/CollaborationIcon';
import { defaultAppHeaderProps } from '../../types/layout/layoutTypes';
import ShareNEarnIcon from '../../assets/icons/ShareNEarnIcon';
import SmartLinksIcon from '../../assets/icons/SmartLinksIcon';
import PaymentsIcon from '../../assets/icons/PaymentsIcon';
import ReferralsIcon from '../../assets/icons/ReferralsIcon';
import SponsorshipsIcon from '../../assets/icons/SponsorshipsIcon';
import TrashIcon from '../../assets/icons/TrashIcon';
import withSlideUpModal from '../../utils/hoc/withSlideUpModalComponent';
import AccountDeletion from '../../components/account/AccountDeletion';
import LogoutIcon from '../../assets/icons/LogoutIcon';
import SubscriptionIcon from '../../assets/icons/SubscriptionIcon';
import MonoWhatsAppIcon from '../../assets/icons/MonoWhatsAppIcon';
const AccountDeletionModal = withSlideUpModal(AccountDeletion, "", true);

const ProfilePage = () => {
    const dispatch: AppDispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector((state: RootState) => state.auth.user);
    const socialAccounts = useSelector((state: RootState) => state.influencer.social_accounts);
    const influencer = useSelector((state: RootState) => state.influencer.influencer);

    const maxSocialAccountsConfig = useSelector((state: RootState) => state.auth?.configurations?.max_social_accounts || {});
    const [isAccountDeletionModalActive, setAccountDeletionModalActive] = React.useState(false);
    const allPlatformsAdded = useMemo(() => {
        return Object.values(platforms).every(platform => {
            const maxForPlatform = maxSocialAccountsConfig[platform.id] || 1;
            const currentCountForPlatform = socialAccounts.filter((account) => account.social_account.platform === platform.id).length;
            return currentCountForPlatform >= maxForPlatform;
        })
    }, [socialAccounts, maxSocialAccountsConfig]);


    useEffect(() => {
        dispatch(setHeader({
            generic: false,
            page: {
                title: "My Profile",
                onBackClick: () => {
                    navigate(-1);
                }
            }
        }))

        return () => {
            dispatch(setHeader(defaultAppHeaderProps))
        }
    }, [])

    const formatDOB = (dateStr: string) => {
        const date = new Date(dateStr);

        const day = date.getDate();
        const year = date.getFullYear();
        const month = date.toLocaleString("en-US", { month: "long" });

        const getSuffix = (d: number) => {
            if (d > 3 && d < 21) return "th";
            switch (d % 10) {
                case 1: return "st";
                case 2: return "nd";
                case 3: return "rd";
                default: return "th";
            }
        };

        return `${day}${getSuffix(day)} ${month}, ${year}`;
    };

    return (
        <>
            <div className='app-page'>
                <div className="app-card p-2">
                    <div className="d-flex align-items-center gap-3 p-2">
                        <div className="profile-avatar">
                            {
                                user?.profile_photo_url ? (
                                    <img src={user?.profile_photo_url} alt={user?.name ?? 'User'} className='user-profile-image' />
                                ) : (
                                    socialAccounts?.[0]?.social_account?.profile_picture_url ? (
                                        <img src={socialAccounts?.[0]?.social_account?.profile_picture_url} alt={user?.name ?? 'User'} className='user-profile-image' />
                                    ) : (
                                        <Avatar name={user?.name} size='3.75rem' className='user-profile-image' />
                                    )
                                )
                            }
                            <span className='profile-avatar-edit-icon cursor-pointer' onClick={() => dispatch(toggleProfileUpdateModal(true))}>
                                <EditIcon />
                            </span>
                        </div>
                        <div className="d-flex flex-column gap-1">
                            <span className="fw-600 text-dark fs-16">{influencer?.name}</span>
                            <span className="text-muted fw-400 fs-14 d-flex align-items-center gap-1">
                                <PhoneIcon />
                                {influencer?.mobile}
                            </span>
                            {
                                influencer?.dob &&
                                <span className="text-muted fw-400 fs-14 d-flex align-items-center gap-1">
                                    <BirthdayIcon />
                                    {formatDOB(influencer?.dob ?? '')}
                                </span>
                            }
                        </div>
                    </div>
                    <div className="profile-social-accounts mt-4">
                        {
                            ((socialAccounts ?? []).length === 0) &&
                            <div className="d-flex px-3 flex-column align-items-center justify-content-center gap-1">
                                <span className='text-muted fw-500 fs-16 text-center'>No Social Accounts Added</span>
                                <span className='text-muted fw-400 fs-14 text-center'>Add a Social Account to Get Collaboration Opportunities</span>
                            </div>
                        }
                        {
                            (socialAccounts ?? []).map((socialAccount, i) => {
                                return (
                                    <SocialAccountProfileCard socialAccount={socialAccount} key={i} />
                                )
                            })
                        }
                        {
                            (!allPlatformsAdded) &&
                            <div className="mt-1 w-100 d-flex justify-content-center align-items-center">
                                <span onClick={() => dispatch(toggleAddSocialAccountModal({ active: true }))} className='text-primary fw-600 fs-14 cursor-pointer'>+ ADD NEW ACCOUNT</span>
                            </div>
                        }
                    </div>
                </div>
                <div className="app-card mt-4 p-3">
                    <div className="d-flex flex-column gap-3">
                        <Link to="/collaborations" className="profile-menu-item">
                            <CollaborationIcon />
                            <span className='fw-400 fs-16 text-dark'>My Collaborations</span>
                        </Link>
                        <Link to="/conversion" className="profile-menu-item">
                            <ShareNEarnIcon />
                            <span className='fw-400 fs-16 text-dark'>My Share & Earn</span>
                        </Link>
                        <Link to="/smart-links" className="profile-menu-item">
                            <SmartLinksIcon />
                            <span className='fw-400 fs-16 text-dark'>My Smart Links</span>
                        </Link>
                    </div>
                </div>
                <div className="app-card mt-4 p-3">
                    <div className="d-flex flex-column gap-3">
                        <Link to="/subscription" className="profile-menu-item">
                            <SubscriptionIcon />
                            <span className='fw-400 fs-16 text-dark'>Subscription</span>
                        </Link>
                        <Link to="/wallet" className="profile-menu-item">
                            <PaymentsIcon />
                            <span className='fw-400 fs-16 text-dark'>Payments</span>
                        </Link>
                    </div>
                </div>
                <div className="app-card mt-4 p-3">
                    <div className="d-flex flex-column gap-3">
                        <Link to="/referral" className="profile-menu-item">
                            <ReferralsIcon />
                            <span className='fw-400 fs-16 text-dark'>Referrals</span>
                        </Link>
                        <Link to="/campaign" className="profile-menu-item">
                            <SponsorshipsIcon />
                            <span className='fw-400 fs-16 text-dark'>Sponsorships</span>
                        </Link>
                    </div>
                </div>
                <div className="app-card mt-4 p-3">
                    <div className="d-flex flex-column gap-3">
                        <Link to={`https://api.whatsapp.com/send?phone=${WHATSAPP_SUPPORT_NUMBER}`} className="profile-menu-item cursor-pointer" target="_blank">
                            <MonoWhatsAppIcon />
                            <span className='fw-400 fs-16 text-dark'>Support</span>
                        </Link>
                        <Link className="profile-menu-item cursor-pointer" to={{ pathname: '/logout' }}>
                            <LogoutIcon />
                            <span className='fw-400 fs-16 text-dark'>Logout</span>
                        </Link>
                    </div>
                </div>
                <div className="app-card mt-4 p-3">
                    <div className="d-flex flex-column gap-3">
                        <span className="profile-menu-item cursor-pointer" onClick={() => setAccountDeletionModalActive(true)}>
                            <TrashIcon />
                            <span className='fw-400 fs-16 text-dark'>Request Account Deletion</span>
                        </span>
                    </div>
                </div>
            </div>
            <AccountDeletionModal isActive={isAccountDeletionModalActive} onClose={() => setAccountDeletionModalActive(false)} />
        </>
    )
}

export default ProfilePage